import React from "react";
import "./StateDropdown.css";

interface StateDropdownProps {
  onInputChange: (value: string) => void;
  isVisible: boolean;
  value: string;
}

const states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];

const StateDropdown: React.FC<StateDropdownProps> = ({
  onInputChange,
  isVisible,
  value,
}) => {
  if (!isVisible) return null;

  const normalizedValue = value.toLowerCase();

  return (
    <div className="email-form">
      <div className="form-input-title">Select State *</div>
      <select
        className="email-input"
        onChange={(e) => onInputChange(e.target.value)}
        value={
          states.find((state) => state.toLowerCase() === normalizedValue) || ""
        }
      >
        <option value="" disabled>
          -- Select a State --
        </option>
        {states.map((state) => (
          <option key={state} value={state}>
            {state}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StateDropdown;
